<template>
  <v-footer
      id="pageFooter"
      class="p-3"
      padless
  >
    <div class="row mr-8">
      <div class="col-auto">
        <i class="fa-brands fa-cc-amazon-pay font24px transform-icon"></i>
        <span class="pr-2">پرداخت امن </span>
      </div>
      <div class="col-auto">
        <i class="fa-solid fa-headphones font24px transform-icon"></i>
        <span class="pr-2">پشتیبانی 24 ساعته </span>
      </div>
      <div class="col-auto">
        <i class="fa-solid fa-comments-question-check font24px transform-icon"></i>
        <span class="pr-2">مشاوره رایگان </span>
      </div>
    </div>

    <div class="row border-top-primary">
      <div class="col pb-0">
        <router-link class="mb-4" to="/">
          <img :src="getImgUrl('footerLogo.jpg')" alt="لوگو ایوان خانه" height="40"/>
        </router-link>
        <div class="d-flex flex-column">

          <router-link class="my-2" to="AboutUs">
            درباره ما
          </router-link>
          <router-link class="my-2" to="ConnectUs">
            تماس با ما
          </router-link>
          <router-link class="my-2" to="RulesOfRegulation">
            قوانین و مقرارات و حریم خصوصی
          </router-link>
          <router-link v-if="isLoggedIn" class="my-2" to="CriticsAndSuggestions">
            انتقادات و پیشنهادات
          </router-link>
          <span v-else class="my-2" @click="showNeedLogin">

            انتقادات و پیشنهادات
          </span>
          <router-link class="my-2" to="FAQ">
            سوالات متداول
          </router-link>
          <router-link class="my-2" to="Support">
            پشتیبانی
          </router-link>
        </div>
      </div>
      <div class="col pb-0">
        <h6 class="mb-5">مطالب مفید</h6>
        <div class="d-flex flex-column">
          <router-link class="my-2" to="NewsesList">
            اخبار
          </router-link>
          <router-link class="my-2" to="ArticlesList">
            مقالات
          </router-link>
          <router-link class="my-2" to="ReviewsList">
            نقد و بررسی
          </router-link>
        </div>
      </div>
      <div class="col pb-0">
        <h6 class="mb-5">خدمات</h6>
        <div class="d-flex flex-column">
          <router-link class="my-2" to="OnlinePaymentHome">
            فروشگاه با پرداخت آنلاین
          </router-link>
          <router-link class="my-2" to="OfflinePaymentHome">
            فروشگاه با پرداخت آفلاین
          </router-link>
          <router-link class="my-2" to="SearchTags">
            شبکه اجتماعی
          </router-link>
        </div>
      </div>
      <div class="col pb-0">
        <h6 class="mb-5">ارتباط با ما</h6>
        <div class="d-flex flex-column">
          <div class="my-2 pointer" @click="openPhone('02177896985')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-regular fa-phone-volume font18px"></i></div>
              <div>02177896985</div>
            </div>
          </div>
          <div class="my-2 pointer" @click="openPhone('09358171304')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-regular fa-comment-sms font18px"></i></div>
              <div>09358171304</div>
            </div>
          </div>
          <div class="my-2 pointer" @click="$openLink('mailto:' + 'Info@eyvankhaneh.com')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-regular fa-envelope font18px ml-6"></i></div>
              <div class="font12px">Info@eyvankhaneh.com</div>
            </div>
          </div>
          <div class="my-2 pointer" @click="openPhone('09358171304')">
            <div class="d-flex justify-space-between">
              <div><i class="fa-solid fa-headphones font18px"></i></div>
              <div>09358171304</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto pl-1 pb-0" style="max-width: 120px">
        <h6 class="mb-5">شبکه اجتماعی</h6>
    <div class="row">
      <div class="col-6 p-1 text-center " v-for="(item,i) in socialLinks" :key="i">
        <a :href="item.Link" target="_blank">
          <v-avatar size="35">
            <img :src="$replaceHttps(item.FileUrl)">
          </v-avatar>
        </a>
      </div>
    </div>
      </div>
      <div class="col pb-0 text-center pr-1">
        <h6 class="mb-5">اپلیکیشین اندروید</h6>
        <div  class="row">
          <div class="col-12 text-center  flex-column d-flex py-0 justify-content-center align-items-center">
            <a href="https://play.google.com/store/apps/details?id=app.eyvankhaneh" target="_blank">
            <img :src="getImgUrl('googlePlay.svg')"  width="150" alt="گوگل پلی" >
            </a>
            <a href="https://myket.ir/app/app.eyvankhaneh" target="_blank">
            <img :src="getImgUrl('mayket.svg')" class="my-5"  width="150" alt="مایکت">
            </a>
            <a href="https://myket.ir/app/app.eyvankhaneh" target="_blank">
            <img :src="getImgUrl('bazar.png')"   width="150" alt="گوگل پلی" >
            </a>
          </div>

        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-12  justify-end d-flex ">
        <v-img :src="getImgUrl('iso.png')"   max-width="100" height="100" alt="iso" contain  @click="showISOImageDialog=true" ></v-img>
        <v-img id='nbqeesgtsizpfukzjzpeoeuk' max-width="100" height="100" class="mx-2" contain style='cursor:pointer' onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=209678&p=uiwkobpdpfvlgvkajyoemcsi", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")' alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=209678&p=odrflymabsiywlbqyndtaqgw' ></v-img>

        <a  rel="origin" href="https://trustseal.enamad.ir/?id=183520&amp;Code=5budxrMagrSii26Mbe4h"  target="_blank">
          <v-img src="https://trustseal.enamad.ir/logo.aspx?id=183520&amp;Code=5budxrMagrSii26Mbe4h" contain alt="" style="cursor:pointer" id="5budxrMagrSii26Mbe4h" max-width="100" height="100"></v-img>
        </a>

      </div>
    </div>
    <div class="row">
      <a href="https://www.izisys.com/Home" target="_blank" class="col-12 text-center py-0">طراح: <span> شرکت ایده زرین پرهام</span></a>
      <div class="col-12 text-center pb-0">تمامی حقوق وبسایت محفوظ و در اختیار <span> ایوانخانه </span> میباشد.</div>
    </div>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary"    >
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="showISOImageDialog" width="500">
      <v-card>
        <v-img :src="getImgUrl('iso.jpg')"    alt="iso"  @click="showISOImageDialog"></v-img>

      </v-card>
    </v-dialog>

  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    icons: [
      'mdi-facebook',
      'mdi-twitter',
      'mdi-linkedin',
      'mdi-instagram',
    ],
    isLoggedIn:false,
    showISOImageDialog:false,
    showResult:false,
    resultText:'',
    socialLinks:null
  }),
  mounted() {
    this.isLoggedIn = this.$store.getters.getIsLoggedIn
    this.getSocialLinks()

  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    showNeedLogin(){
      this.resultText='برای مشاهده این بخش باید وارد شوید'
      this.showResult=true
    },
    getSocialLinks(){
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Publicly/LocalSocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.socialLinks = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    openPhone(tel) {
      this.$openLink("tel:" + tel)
    },
  }
}
</script>

<style scoped>

</style>
